



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { EventLogsObjectType, EventLogActions } from '@/modules/shared/eventlogs/enums';

@Component({
    components: {
    },
})
export default class EventLog extends Vue {
    @Prop({required: true})
    public value!: IEventLog;
    private momentValue: Date = new Date();
    private showDetails: boolean = false;

    private mounted() {
        this.momentValue = new Date(this.value.moment);
    }

    get icon() {
        switch (this.value.action) {
            case EventLogActions.Created:
                return 'fas fa-plus';
                break;
            case EventLogActions.Updated:
                return 'fas fa-edit';
                break;
            case EventLogActions.Deleted:
                return 'fas fa-trash';
                break;
            case EventLogActions.Completed:
                return 'fas fa-check-double';
                break;
            case EventLogActions.Accepted:
                return 'fas fa-check-circle';
                break;
            case EventLogActions.Declined:
                return 'fas fa-times';
                break;
            case EventLogActions.Duplicated:
                return 'fas fa-copy';
                break;
            case EventLogActions.Note:
                return 'fas fa-clipboard';
                break;
            case EventLogActions.Mail:
                return 'fas fa-paper-plane';
                break;
            case 53:
                return 'fas fa-sms';
                break;
            case EventLogActions.PhoneCall:
                return 'fas fa-phone';
                break;
            case EventLogActions.Report:
                return 'fas fa-file-code';
                break;
            case EventLogActions.FileCreated:
                return 'fas fa-file';
                break;
            case EventLogActions.FileUpdated:
                return 'fas fa-file';
                break;
            case EventLogActions.FileDeleted:
                return 'fas fa-file';
                break;
        }
        return '';
    }

    get color() {
        switch (this.value.action) {
            case EventLogActions.Created:
                return 'success';
                break;
            case EventLogActions.Updated:
                return 'warning';
                break;
            case EventLogActions.Deleted:
                return 'danger';
                break;
            case EventLogActions.Completed:
                return 'success';
                break;
            case EventLogActions.Accepted:
                return 'success';
                break;
            case EventLogActions.Declined:
                return 'danger';
                break;
            case EventLogActions.Duplicated:
                return 'info';
                break;
            case EventLogActions.Note:
                return 'info';
                break;
            case EventLogActions.Mail:
                return 'info';
                break;
            case EventLogActions.PhoneCall:
                return 'info';
                break;
            case EventLogActions.Report:
                return 'info';
                break;
            case EventLogActions.FileCreated:
                return 'success';
                break;
            case 53:
                return 'info';
                break;
            case EventLogActions.FileUpdated:
                return 'warning';
                break;
            case EventLogActions.FileDeleted:
                return 'danger';
                break;
        }
        return '';
    }

    get bodyText() {
        while (this.value.message.indexOf('\n') !== -1) {
            this.value.message = this.value.message.replace('\n', '<br />');
        }
        return this.value.message;
    }

    get alertColor() {
        return 'alert alert-' + this.color;
    }
    get momentString() {
        return moment(this.momentValue).format('DD/MM/YYYY HH:mm');
    }
}
